import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context/auth-context';
import { MealsContextProvider } from './context/meals-context';
import { MealPlansContextProvider } from './context/meal-plans-context';
import { ShoppingListContextProvider } from './context/shopping-list-context';

// StrictMode is intentionally omitted: MealsContextProvider calls refresh()
// (a network request) in its mount effect. StrictMode double-invokes effects
// in development, which would cause a duplicate API call on every page load.
const root = createRoot(document.getElementById('root')!);
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}

root.render(
  <BrowserRouter>
    <MealsContextProvider>
      <MealPlansContextProvider>
        <ShoppingListContextProvider>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </ShoppingListContextProvider>
      </MealPlansContextProvider>
    </MealsContextProvider>
  </BrowserRouter>
);
